import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_PATIENT_EXERCISES_BY_ID_KEY } from '_api/queries/exercise/useGetAllPatientExercisesByID';
import { AddExerciseToPatientPayload, CompletedDatePayload } from '_api/types';

export const SET_EXERCISE_COMPLETED_DATE = 'set-exercise-completed-date';

export const useCompletePatientExercise = () => {
  const queryClient = useQueryClient();
  return useApiMutation<AddExerciseToPatientPayload, CompletedDatePayload>(
    ({ patientContentId }) => `/exercise/set-exercise-completed-date/${patientContentId}`,
    'put',
    {},
    {
      mutationKey: [SET_EXERCISE_COMPLETED_DATE],
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_EXERCISES_BY_ID_KEY],
        });
      },
    },
  );
};
